import React from 'react'
import { IssuingAddusers } from './issuingAddusers'

export const IssuingAddUser = () => {
  return (
    <IssuingAddusers />
  )
}
